import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { ProduktionsomradeDetailDTO } from "~app/common/models/produktionsomrade/ProduktionsomradeDetailDTO";
import { ProduktionsomradeDTO } from "~app/common/models/produktionsomrade/ProduktionsomradeDTO";
import { RecalculateDirektutbyteResponseDTO } from "~app/common/models/produktionsomrade/RecalculateDirektutbyteResponseDTO";
import { ApiClientService } from "../../../common/services/api-client.service";

@Injectable({
    providedIn: "root"
})
export class ProduktionsomradeService {
    private readonly apiClient = inject(ApiClientService);

    getAllProduktionsomraden(): Observable<ProduktionsomradeDTO[]> {
        return this.apiClient.get<ProduktionsomradeDTO[]>("administration/produktionsomrade", false);
    }

    getProduktionsomradeById(id: number): Observable<ProduktionsomradeDetailDTO> {
        return this.apiClient.get<ProduktionsomradeDetailDTO>(`administration/produktionsomrade/${id}`, false);
    }

    updateProduktionsomrade(id: number, entity: ProduktionsomradeDetailDTO): Observable<void> {
        return this.apiClient.put<ProduktionsomradeDetailDTO, void>(`administration/produktionsomrade/${id}`, entity, false);
    }

    recalculateDirektutbyteForProduktionsomrade(id: number): Observable<RecalculateDirektutbyteResponseDTO> {
        return this.apiClient.post<null, RecalculateDirektutbyteResponseDTO>(`administration/produktionsomrade/${id}/recalculate-direktutbyte`, null, false);
    }
}
